/* eslint-disable */

export const accuracySentVolumeBuy = {
    GET_ACCURACY_SENT_VOLUME_BUY_REQUEST: 'GET_ACCURACY_SENT_VOLUME_BUY_REQUEST',
    GET_ACCURACY_SENT_VOLUME_BUY_SUCCESS: 'GET_ACCURACY_SENT_VOLUME_BUY_SUCCESS',
    GET_ACCURACY_SENT_VOLUME_BUY_FAILURE: 'GET_ACCURACY_SENT_VOLUME_BUY_FAILURE',
};
